import { SelectionSet } from "aws-amplify/api";
import { InfiniteData } from "@tanstack/react-query";
import { Schema } from "queryClient";
import { TypeKeysEnum } from "./General.types";
import utils from "utils";

export const EffortRuleSelectionSet = [
  "id",
  "owner",
  "createdAt",
  "updatedAt",
  "websiteType",
  "system.*",
  "systemID",
  "effort",
  "taskType.*",
  "taskTypeID",
  "description",
] as const;

export type EffortRule = SelectionSet<
  Schema["EffortRule"]["type"],
  typeof EffortRuleSelectionSet
>;

export type CreateEffortRuleInput = Schema["EffortRule"]["createType"];

export type UpdateEffortRuleInput = Schema["EffortRule"]["updateType"];

export type InfiniteEffortRuleList = {
  effortRuleList: EffortRule[];
  nextToken: string | null;
};

export type InfiniteEffortRuleData =
  | InfiniteData<InfiniteEffortRuleList, unknown>
  | undefined;

export const EffortRuleTypeKeys: TypeKeysEnum<EffortRule> = {
  id: {
    type: "id",
    isArray: false,
    isRequired: true,
    isSortable: true,
    isSearchable: false,
    formatter: (data) => data.id,
  },
  createdAt: {
    type: "datetime",
    isArray: false,
    isRequired: true,
    isSortable: true,
    isSearchable: false,
    formatter: (data) =>
      utils.dates.getDateAndTimeInGermanFromAWSDateTimeFormat(data.createdAt) +
      " Uhr",
  },
  updatedAt: {
    type: "datetime",
    isArray: false,
    isRequired: true,
    isSortable: true,
    isSearchable: false,
    formatter: (data) =>
      utils.dates.getDateAndTimeInGermanFromAWSDateTimeFormat(data.updatedAt) +
      " Uhr",
  },
  owner: {
    type: "string",
    isArray: false,
    isRequired: true,
    isSortable: false,
    isSearchable: false,
    formatter: (data) => data.owner ?? "",
  },
  websiteType: {
    type: "string",
    isArray: false,
    isRequired: true,
    isSortable: true,
    isSearchable: true,
    formatter: (data) => data.websiteType,
  },
  system: {
    type: "entity",
    isArray: false,
    isRequired: true,
    isSortable: false,
    isSearchable: false,
    formatter: () => "",
  },
  systemID: {
    type: "id",
    isArray: false,
    isRequired: true,
    isSortable: true,
    isSearchable: false,
    formatter: (data) => data.systemID,
  },
  effort: {
    type: "integer",
    isArray: false,
    isRequired: true,
    isSortable: true,
    isSearchable: false,
    formatter: (data) => data.effort.toString(),
  },
  taskType: {
    type: "entity",
    isArray: false,
    isRequired: true,
    isSortable: false,
    isSearchable: false,
    formatter: () => "",
  },
  taskTypeID: {
    type: "id",
    isArray: false,
    isRequired: true,
    isSortable: true,
    isSearchable: false,
    formatter: (data) => data.taskTypeID,
  },
  description: {
    type: "string",
    isArray: false,
    isRequired: false,
    isSortable: false,
    isSearchable: true,
    formatter: (data) => data.description ?? "",
  },
};

export const isKeyOfEffortRule = (key: string): key is keyof EffortRule =>
  key in EffortRuleTypeKeys;
